import { render, staticRenderFns } from "./AffiliatesBooking.vue?vue&type=template&id=644ac5f6&scoped=true&"
import script from "./AffiliatesBooking.vue?vue&type=script&lang=js&"
export * from "./AffiliatesBooking.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesBooking.vue?vue&type=style&index=0&id=644ac5f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ac5f6",
  null
  
)

export default component.exports